import axios from '@/utils/request';
//证书查询
export function certificate(data) {
	return axios({
		url: '/public_query/certificate',
		method: 'post',
		data
	});
}
//证书生成
export function generateCertificate(id, token = null) {
	return axios({
		url: '/my/download/' + id,
		method: 'get',
		params: {
			token
		}
	});
}
//证书查询详情
export function queryDetail(id, token = null) {
	return axios({
		url: '/public_query/certificate/' + id,
		method: 'get',
		params: {
			token
		}
	});
}
//历史证书查询详情
export function queryHistoryDetail(id, token = null) {
	return axios({
		url: '/public_query/archived_cert/' + id,
		method: 'get',
		params: {
			token
		}
	});
}
//我的证书列表
export function certificateList(data) {
	return axios({
		url: '/my/certificate',
		method: 'get',
		data
	});
}
//证书详情
export function certificateDetail(id) {
	return axios({
		url: '/my/certificate/' + id,
		method: 'get'
	});
}
// export function certificateDownload(id) {
//   return axios({
//     url: "/my/download/" + id,
//     method: "get",
//   });
// }
// 我的历史证书详情
export function historyCertificateDetail(id) {
	return axios({
		url: '/my/archived_cert/' + id,
		method: 'get'
	});
}
